import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';

import DeliveryInfoFormInline from 'components/common/DeliveryInfoForm/DeliveryInfoFormInline';
import RestaurantCard from 'components/common/RestaurantCard';
import MapModal from 'components/common/MapModal';

import { getQueryString } from 'utils/address.util';
import {
  loadRestaurants,
  toggleFilterTag,
  setSelectedTags,
} from 'redux/restaurants/actions';
import { getFilteredChefs } from 'selectors/restaurants';
import { Link, useLocation } from 'react-router-dom';
import MenuCardPlaceholder from '../MadeForYou/MenuCardPlaceholder';

import './index.scss';
import FilterScroller from 'components/common/FilteredMenu';
import InfiniteScrolling from 'components/common/InfinteScroller';
import { authenticateWithToken } from 'api/authApi';
import { signinRequest } from 'redux/actions/authActions';
const queryString = require('query-string');

const BrowseRestaurants = () => {
  const dispatch = useDispatch();
  const userSignedIn = useSelector(state => get(state, 'user.user.confirmed'));
  const {
    loading,
    loadingMore,
    currentPage,
    totalPage,
    fullCount,
    filterTags,
    selectedFilterTags,
    filterTagsIcon,
  } = useSelector(state => state.restaurants);
  const debounceTimer = useRef(null);
  const [formDataQuery, setFormDataQuery] = useState(getQueryString());
  const [filteredChefs, filteredTitle] = useSelector(getFilteredChefs);
  const [showMapModal, setShowMapModal] = useState(false);
  const [mapModalData, setMapModalData] = useState({});
  const isLoadingPagination = totalPage > currentPage;
  const { search, state } = useLocation();
  const { token } = queryString.parse(search);
  function openRestaurantLocation({
    firstName,
    shortAddress,
    slug,
    latitude,
    longitude,
  }) {
    setMapModalData({
      firstName,
      shortAddress,
      slug,
      latitude,
      longitude,
    });
    setShowMapModal(true);
  }
  async function fetchUserData(token) {
    try {
      const auth = await authenticateWithToken({ Authorization: `Bearer ${token}` });
      if (auth && auth.user && auth.user.confirmed) {
        dispatch(signinRequest(auth));
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    } catch (e) {
      console.log('error', e);
    }
  }
  useEffect(() => {
    if (token) {
      fetchUserData(token);
    }
  }, [token]);
  const selectAll = () => {
    dispatch(setSelectedTags(filterTags));
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      dispatch(
        loadRestaurants({
          queryParams: getQueryString({
            preset_category_names: filterTags,
          }),
        }),
      );
    }, 1000);
  };
  const fetchData = ({ page }) => {
    dispatch(
      loadRestaurants({
        queryParams: formDataQuery,
        page: page ? page : currentPage,
        loadingMore: false,
      }),
    );
  };

  useEffect(() => {
    fetchData({ page: 1 });
  }, [formDataQuery, userSignedIn]);

  const onDeliveryFormSubmit = query => {
    setFormDataQuery(query);
  };
  const handleSelect = filterTags => {
    dispatch(setSelectedTags(filterTags));

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      dispatch(
        loadRestaurants({
          queryParams: getQueryString({
            preset_category_names: filterTags,
          }),
        }),
      );
    }, 1000);
  };
  const handleCancel = () => {
    dispatch(
      loadRestaurants({
        queryParams: formDataQuery,
        page: 1,
      }),
    );
    dispatch(setSelectedTags([]));
  };
  const onLoadMore = () => {
    if (!loadingMore && isLoadingPagination) {
      dispatch(
        loadRestaurants({
          queryParams: getQueryString({
            preset_category_names: selectedFilterTags,
          }),
          page: currentPage + 1,
          loadingMore: true,
        }),
      );
    }
  };
  const loadingPlaceholder = (
    <div className="slick-initialized slick-slider slick slick-grid home--carousel">
      <div className="slick-list">
        <div className="slick-track slick-track--wrapped">
          <MenuCardPlaceholder />
        </div>
      </div>
    </div>
  );
  return (
    <main>
      <DeliveryInfoFormInline
        isAbleToChangeReceivingMethod
        onSubmit={onDeliveryFormSubmit}
      />

      <div className="container py-0">
        <div className="row align-items-center">
          <div className="col-12 d-md-flex align-items-center text-center text-md-left">
            {loading ? (
              <h3 className="page-title mt-2 mb-4 text-center text-md-left">
                Searching for restaurants near you...
              </h3>
            ) : (
              <>
                <h1
                  className="page-title mt-0 mb-md-0 d-block d-xl-inline-block text-center text-md-left"
                  style={{ fontSize: '20px' }}
                >
                  {fullCount} Restaurant
                  {fullCount === 1 ? '' : 's'}
                </h1>
                <div className="alert alert-custom mb-0 ml-md-4">
                  <img src="assets/img/ico-deliver-human-1.svg" alt="Waiter" />
                  Free online ordering
                </div>
              </>
            )}
          </div>
        </div>

        {loading && loadingPlaceholder}

        {!loading && (
          <>
            {filterTags.length > 0 && (
              <div className="rests-filter__section pt-xl-0 pt-4 mt-2">
                <div className="rests-filter__wrap">
                  <FilterScroller
                    filterTags={filterTags}
                    filterTagsIcon={filterTagsIcon}
                    selectedFilterTags={selectedFilterTags}
                    setSelectedFilterTags={setSelectedTags}
                    loading={loading}
                  />
                </div>
                <div className="d-flex clr-btn-wrap align-items-center justify-content-end">
                  <div>
                    <div className="d-flex align-items-center">
                      <button
                        type="button"
                        className="btn btn-sm btn-link"
                        onClick={handleCancel}
                      >
                        Clear selected
                      </button>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary px-4"
                        onClick={() => handleSelect(filterTags)}
                      >
                        Select all
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <InfiniteScrolling
              isLoading={isLoadingPagination}
              onLoadMore={onLoadMore}
            >
              {' '}
              <div className="made--section-content mb-xl-1">
                <h3 className="mb-4" style={{ fontSize: '15px' }}>
                  {filteredTitle} restaurants
                </h3>
                {userSignedIn && (
                  <Link to="/favorites">
                    View Your Favorites / Saved Orders
                  </Link>
                )}
                <div className="mt-4 slick-initialized slick-slider slick slick-grid">
                  <div className="slick-list">
                    {filteredChefs.length === 0 ? (
                      <div className="check__other">
                        <span>
                          <img src="/assets/img/foodicon.svg" alt="foodicon" />
                        </span>
                        <p>Hmm.. It looks like there are no options.</p>
                        <br />
                        <p>This could be for a few reasons.</p>
                        <br />
                        <p>
                          1) Click Update Details above and update your delivery
                          date and time. Most vendors require a minimum of 24
                          hours notice and some even require 48 hours. So the
                          further out the delivery is scheduled, the more
                          options you will likely see.
                        </p>
                        <br />
                        <p>
                          2) Update your delivery address, most of our vendors
                          are near the core of each city. If you still don't see
                          results, you can contact us at support@cateredclub.com
                          and we can work on getting some results in your area!
                        </p>
                      </div>
                    ) : null}
                    <div className="slick-track slick-track--wrapped pt-1">
                      {filteredChefs.map(chef => {
                        const {
                          id,
                          chefIds,
                          slug,
                          name,
                          distance,
                          searchResultImageUrl,
                          shortAddress,
                          cuisineTypes,
                          chefImages,
                          latitude,
                          longitude,
                          distanceUnit,
                          description,
                          favorite,
                          availableForOrdering,
                          presetTags,
                        } = chef;
                        return (
                          <RestaurantCard
                            key={`${id}-${slug}`}
                            firstName={name}
                            availableForOrdering={availableForOrdering}
                            profileImageUrl={
                              chefImages[chefIds[0]].profileImageUrl
                            }
                            tagNames={cuisineTypes}
                            mainImageUrl={searchResultImageUrl}
                            {...{
                              favorite,
                              latitude,
                              longitude,
                              description,
                              presetTags,
                              distance,
                              distanceUnit,
                              shortAddress,
                              slug: `/chefs/${slug}`,
                              openRestaurantLocation,
                            }}
                          />
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </InfiniteScrolling>
          </>
        )}
      </div>

      <MapModal
        show={showMapModal}
        onClose={() => setShowMapModal(false)}
        firstName={mapModalData.firstName}
        shortAddress={mapModalData.shortAddress}
        slug={mapModalData.slug}
        latitude={mapModalData.latitude}
        longitude={mapModalData.longitude}
      />
    </main>
  );
};

export default BrowseRestaurants;
